import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatMoney, getInlineLoader, setCookie } from "../Helpers";
import {
	STR_ACCEPTED_RIDE_REQUESTS,
	STR_AGENCY_REPORTS,
	STR_AGENT_REQUESTS_HISTORY,
	STR_ALL_RIDE_REQUESTS,
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_COULD_NOT_PROCESS_REQUEST,
	STR_DEBTS_BALANCE,
	STR_LINK_SUPERVISOR,
	STR_LOGOUT,
	STR_MY_COACH,
	STR_MY_CREATED_AGENT_REQUESTS,
	STR_MY_PARTICIPATED_AGENT_REQUESTS,
	STR_MY_PROCESSED_AGENT_REQUESTS,
	STR_MY_REVENUES,
	STR_MY_STUDENTS,
	STR_MY_SUBSCRIPTION,
	STR_OTHER_SETTINGS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_PLEASE_CONTACT_SUPPORT_TO_BECOME_RIDER,
	STR_RIDER_DASHBOARD,
	STR_SELECT_ACCOUNT_TO_MANAGE,
	STR_SET_CURRENCY,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_TERMINATED_RIDE_REQUESTS,
	STR_UNACCEPTED_RIDE_REQUESTS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_USER_REPORT,
	STR_VERIFY_YOUR_PROFILE,
	STR_WALLET_BALANCE,
	STR_WHATSAPP_SETUP,
	STR_YOUR_PROFILE,
	STR_YOUR_REPORTS
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdAnalytics, MdContactPage, MdCreditCard, MdDashboard, MdDetails, MdInfoOutline, MdLink, MdLogout, MdOutlineDashboard, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdOutlineWarning, MdPerson, MdSupervisorAccount, MdSupportAgent, MdTranslate, MdVerified, MdWallet, MdWhatsapp } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import { GrCurrency } from "react-icons/gr";
import { GiTeacher } from "react-icons/gi";
import { FaRegUser } from "react-icons/fa";
import { RiListCheck2, RiListCheck3, RiListOrdered, RiProfileLine } from "react-icons/ri";
import { LiaUserSolid } from "react-icons/lia";
import { IoWarningOutline } from "react-icons/io5";
import OneRiderAccount from '../ones/OneRiderAccount';

export default function View({ riderUuid }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [data, setData] = useState(null);
	const [summary, setSummary] = useState(null);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			getRiderData(),
			getRiderSummary(),
		])
		setReady(true);
	}

	async function getRiderData() {
		await callApi('get-rider-data', {  riderUuid }).then(response => {
			if(response.status === 1) {
				setData(response.data);
			} else {
				appContext.tellError(STR_COULD_NOT_PROCESS_REQUEST[appContext.language]);
			}
		})
	}

	async function getRiderSummary() {
		await callApi('get-rider-dashboard-summary', { riderUuid }).then(response => {
			if(response.status === 1) {
				setSummary(response.data);
			} else {
				appContext.tellError(STR_COULD_NOT_PROCESS_REQUEST[appContext.language]);
			}
		})
	}

	function NormalMenuTile({ title, navTo, count }) {

		const appContext = useContext(AppContext);
		
		return (
			<div className="col-md-4 col-6">
				<div 
					className="bg-surface"
					style={{
						padding: "15px",
						minHeight: "120px",
						marginBottom: "20px",
						borderRadius: "15px",
						cursor: "pointer",
					}}
					onClick={() => {
						appContext.navTo(navTo)
					}}
				>

					<h6
						style={{
							fontSize: "32px"
						}}
						className="font-light"
					>
						{count}
					</h6>

					<h6
						style={{
							fontSize: "12px",
							textTransform: "capitalize"
						}}
						className="font-semi-bold"
					>
						{title}
					</h6>
				</div>
			</div>
		)
	}

	function MoneyMenuTile({ title, navTo, count, isDebt = false }) {
		return (
			<div className="col-md-4 col-6">
				<div 
					className={isDebt ? "bg-dark" : "bg-secondary"}
					style={{
						padding: "15px",
						minHeight: "160px",
						marginBottom: "20px",
						borderRadius: "15px",
						cursor: "pointer",
					}}

					onClick={() => {
						appContext.navTo(navTo)
					}}
				>

					<h6
						style={{
							fontSize: "20px",
							marginTop: "20px",
							marginBottom: "20px"
						}}
						className={isDebt ? "font-bold text-danger" : "font-bold"}
					>
						<span className="d-block" style={{ fontSize: "12px" }}>TZS</span>
						{formatMoney(0)}
					</h6>

					<h6
						style={{
							fontSize: "12px",
							textTransform: "capitalize"
						}}
						className="font-semi-bold"
					>
						{title}
					</h6>
				</div>
			</div>
		)
	}

	useEffect(() => {
		init();
	}, [ riderUuid ])



	if (ready && data && summary) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						

						<div className="col-md-12">
							<div className="card">
								<div className="card-body">
									<h6
										style={{
											fontSize: "18px"
										}}
										className="font-bold"
									>
										{data.firstName} {data.middleName} {data.lastName}
									</h6>

									<h6
										style={{
											fontSize: "18px"
										}}
										className="font-light mt-4 text-end text-secondary"
									>
										{data.riderType} <span className="font-bold">|</span> {data.vehicleBrand} <span className="font-bold">|</span> {data.vehicleColor}
									</h6>

									<h6
										style={{
											fontSize: "18px"
										}}
										className="font-bold text-end"
									>
										{data.vehicleRegistrationNumber}
									</h6>

								</div>
							</div>
						</div>

						<MoneyMenuTile
							title={STR_WALLET_BALANCE[appContext.language]}
							count={summary.walletBalance}
							navTo={{
								item: 'rider-portal',
								subItem: riderUuid,
								moreItem: 'wallet',
							}}
						/>

						<MoneyMenuTile
							title={STR_DEBTS_BALANCE[appContext.language]}
							count={summary.debtsBalance}
							isDebt={true}
							navTo={{
								item: 'rider-portal',
								subItem: riderUuid,
								moreItem: 'debts',
							}}
						/>

						<NormalMenuTile
							title={STR_ALL_RIDE_REQUESTS[appContext.language]}
							count={summary.allRideRequestsCount || 0}
							navTo={{
								item: 'rider-portal',
								subItem: riderUuid,
								moreItem: 'all-ride-requests',
							}}
						/>

						<NormalMenuTile
							title={STR_UNACCEPTED_RIDE_REQUESTS[appContext.language]}
							count={summary.unacceptedRideRequestsCount  || 0}
							navTo={{
								item: 'rider-portal',
								subItem: riderUuid,
								moreItem: 'unaccepted-ride-requests',
							}}
						/>

						<NormalMenuTile
							title={STR_ACCEPTED_RIDE_REQUESTS[appContext.language]}
							count={summary.acceptedRidesCount || 0}
							navTo={{
								item: 'rider-portal',
								subItem: riderUuid,
								moreItem: 'accepted-rides',
							}}
						/>

						<NormalMenuTile
							title={STR_TERMINATED_RIDE_REQUESTS[appContext.language]}
							count={summary.terminatedRidesCount || 0}
							navTo={{
								item: 'rider-portal',
								subItem: riderUuid,
								moreItem: 'terminated-rides',
							}}
						/>

					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}